var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppContent',{attrs:{"resourcePath":_vm.resourcePath,"headers":_vm.headers,"title":_vm.title,"subject":_vm.subject,"item-key":"name","table-props":{ 
    downloadable: false, 
    itemKey: 'name', headers: _vm.headers,
    itemActions: ['edit', 'delete']
    }},on:{"table-item-delete":_vm.onTableItemDelete},scopedSlots:_vm._u([{key:"form",fn:function(slotProps){return [_c('PermissionForm',_vm._b({ref:"form"},'PermissionForm',slotProps,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }